import React from 'react'
import { useTranslation } from 'react-i18next'
import { LayoutBand, Row, H1, Paragraph, Separator } from '@fs/zion-ui'

const HelperModeMessage = () => {
  const [t] = useTranslation()
  return (
    <LayoutBand>
      <Separator size="xl" />
      <Row alignX="center">
        <H1 centered>Together by FamilySearch</H1>
      </Row>
      <Row alignX="center">
        <Paragraph centered>
          {t(
            'helper.mode.not.supported.page.message',
            'Using Together by FamilySearch in Helper Mode is not currently supported. Please conclude your Helper session to use this app.'
          )}
        </Paragraph>
      </Row>
    </LayoutBand>
  )
}

export default HelperModeMessage
